import React, { useState } from "react";
import { AppContext } from "../AppContext.js";

import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import {
  CustomerSearchCriteria,
  InvoiceBean,
  InvoiceSearchCriteria,
  PageListBean,
  PickTicketSearchCriteria,
  RestCustomerListRequest,
  RestInvoiceBeanRequest,
  RestInvoiceListRequest,
  RestPageListBean,
  RestPickTicketListRequest,
  RestReadRequest,
  RestSalesOrderListRequest,
  SalesOrderSearchCriteria,
} from "../ds/ds.js";
import { LogicConstants } from "../ds/LogicConstants.js";
import {
  DatePickerComponent,
  InputTextbox,
} from "../gui_components/UIComponents.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import {
  PopupCustomerModule,
  PopupInvoiceModule,
  PopupPickTicketModule,
  PopupSalesModule,
} from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { CustomerService } from "../services/CustomerService.js";
import { InvoiceService } from "../services/InvoiceService.js";
import { PickTicketService } from "../services/PickTicketService.js";
import { SalesOrderService } from "../services/SalesOrderService.js";

import { RestReportBean } from "../ds/client_ds.js";
import { DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  MultiViewPopup,
  ProgressBar,
  ShowError,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { PickTicketLookupHandler } from "../lookup/PickTicketLookupHandler.js";
import { SalesOrderLookupHandler } from "../lookup/SalesOrderLookupHandler.js";
import { ModuleUtils } from "./ModuleUtils.js";
class ApproveInvoice extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Mass Approve Invoice",
      isShowExitButton: true,
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowResetButton: false,
      criteria: new InvoiceSearchCriteria(),
      criteriaViewShow: false,
      pageList: new RestPageListBean(),
      isInvoiceDataListFound: false,
      ivoiceDatalist: [],
      companyCode: "",
      customerLookupHandler: null,
      pickTicketLookupHandler: null,
      salesOrderLookupHandler: null,
      isShowCustomerModule: false,
      isShowPickTicketModule: false,
      isShowInvoiceModule: false,
      isShowSalesOrderMaintenanceModule: false,
      moduleForPopup: [],
      customerPageListForAutoCompleteList: new Array(),
      showAutoCompletecustomerList: true,
      salesPageListForAutoCompleteList: new Array(),
      showAutoCompleteSOList: true,
      pickTicketPageListForAutoCompleteList: new Array(),
      showAutoCompletePTList: true,
      isShowProgressBarPopup: false,
      invoiceData: new InvoiceBean(),
      error_list: [],
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      order: "asc",
      isDisableFields: false,
      sortField: "",
    };
    this.customerCodeRef = React.createRef();
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    ModuleUtils.getInvoiceStatusList();
    this.initLookupHandlers();
  }
  initLookupHandlers = () => {
    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "customerCode"
    );
    this.setState({ customerLookupHandler: customerLookupHandler });
    let pickTicketLookupHandler = new PickTicketLookupHandler(
      this.companyCode,
      "pickTicketNumber"
    );
    this.setState({ pickTicketLookupHandler: pickTicketLookupHandler });
    let salesOrderLookupHandler = new SalesOrderLookupHandler(
      this.companyCode,
      "salesOrderNumber"
    );
    this.setState({ salesOrderLookupHandler: salesOrderLookupHandler });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  execute = () => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
    this.loadPage(1);
    this.hideAlertCallBack();
  };

  loadPage = (pageNumber) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    criteria.invoiceStatus = LogicConstants.INVOICE_UNAPPROVE_STATUS;
    let pageInput = new PageListBean();
    pageInput.currentPage = pageNumber;
    let listRequest = new RestInvoiceListRequest();
    listRequest.searchCriteria = criteria;
    listRequest.pageInput = pageInput;
    this.loadInvoicesDetailInquiryList(listRequest);
  };
  loadInvoicesDetailInquiryList = (listRequest) => {
    InvoiceService.getInvoicePageList(
      listRequest,
      this.loadInvoicesResponse,
      this.errorCallBack
    );
  };
  loadInvoicesResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.invoicePageList != null) {
      let invoiceList = new Array();
      if (!isEmptyArray(response.data.invoicePageList.invoices)) {
        invoiceList = response.data.invoicePageList.invoices;
      }
      this.setState({
        ivoiceDatalist: invoiceList,
        isInvoiceDataListFound: true,
        isShowProgressBarPopup: false,
        isShowClearCriteriaButton: false,
        isShowResetButton: true,
        isDisableFields: true,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  errorCallBack = (error) => {
    ShowError("Error : ", error);
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowCustomerModule: isOpen,
      isShowPickTicketModule: isOpen,
      isShowInvoiceModule: isOpen,
      isShowSalesOrderMaintenanceModule: isOpen,
      moduleForPopup: [],
    });
  };
  viewCustomerModule = (e, code, rowData) => {
    if (e.detail == 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowCustomerModule: true,
          loadingText: "Executing",
          moduleForPopup: (
            <PopupCustomerModule
              customerCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewPickTicketModule = (e, code, rowData) => {
    if (e.detail == 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowPickTicketModule: true,
          loadingText: "Executing",
          moduleForPopup: (
            <PopupPickTicketModule
              pickTicketCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewInvoiceModule = (e, code, rowData) => {
    if (e.detail == 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowInvoiceModule: true,
          loadingText: "Executing",
          moduleForPopup: (
            <PopupInvoiceModule
              invoiceCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewsalesOrderModule = (e, code, rowData) => {
    if (e.detail == 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowSalesOrderMaintenanceModule: true,
          loadingText: "Executing",
          moduleForPopup: (
            <PopupSalesModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  customerCodeOnChange = (e) => {
    let customerCode = e.target.value;
    this.state.showAutoCompleteCustomerList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
    if (isEmpty(customerCode)) {
      this.state.showAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
      let criteria = this.state.criteria;
      criteria.customerName = "";
      criteria.customerCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        customerPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList === true &&
      customerCode !== ""
    ) {
      this.loadCustomerBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  loadCustomerDetailResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.customer != null) {
      let customerData = response.data.customer;
      if (!isEmpty(customerData)) {
        criteria.customerName = customerData.description;
        criteria.customerCode = customerData.code;
        this.setState({
          criteria: criteria,
        });
      }
    }
  };
  loadCustomerDetail = (customerCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = customerCode;
    input.isLoadChildren = true;
    CustomerService.readCustomer(
      input,
      this.loadCustomerDetailResponse,
      this.errorCallBack
    );
  };
  loadCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new RestPageListBean();
    cust_pageList.pageSize = 10;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.loadCustomerCodeResponse,
      this.errorCallBack
    );
  }
  loadCustomerCodeResponse = (response) => {
    let customerData = response.data.customerPageList.customers;
    let simpleAutoCompleteList = new Array();
    if (customerData.length > 0 && customerData != null) {
      customerData.map((customer) => {
        let simpleItemBean = {
          code: customer.code,
          description: customer.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      customerPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  customerCodeEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.loadCustomerDetail(customerCode);
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCustomerList: showAutoCompleteList });
  };
  onSalesOrderChange = (e) => {
    let salesOrder = e.target.value;
    this.state.showAutoCompleteSOList = true;
    let criteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteSOList;
    if (isEmpty(salesOrder)) {
      this.state.showAutoCompleteSOList = false;
      let showAutoCompleteList = this.state.showAutoCompleteSOList;
      let criteria = this.state.criteria;
      criteria.salesOrderNumber = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteSOList: showAutoCompleteList,
        criteria: criteria,
        salesPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "salesOrderNumber" &&
      showAutoCompleteList === true &&
      salesOrder !== ""
    ) {
      this.loadSalesBySearchString(e.target.value);
    }
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  loadSalesOrderDetail = (salesOrder) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = salesOrder;
    readrestInput.isLockRequired = true;
    SalesOrderService.initSalesOrderModule(
      readrestInput,
      this.loadSalesOrderResponse,
      this.errorCallBack
    );
  };
  loadSalesOrderResponse = (response) => {
    if (
      response.data.salesOrderResponse != null &&
      response.data.salesOrderResponse.salesOrder != null
    ) {
      let criteria = this.state.criteria;
      const salesOrder = response.data.salesOrderResponse.salesOrder;
      criteria.salesOrderNumber = salesOrder.code;
      let showAutoCompleteSOList = false;
      this.setState({
        criteria: criteria,
        showAutoCompleteSOList: showAutoCompleteSOList,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
  };
  loadSalesBySearchString(searchString) {
    let searchCriteria = new SalesOrderSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.salesOrderNumberStartsWith = searchString;
    searchCriteria.salesOrderNumberContains = searchString;
    let pageList = new PageListBean();
    pageList.pageSize = 100;
    let input = new RestSalesOrderListRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    SalesOrderService.getSalesOrderPageList(
      input,
      this.loadBySalesOrderResponse,
      this.errorCallBack
    );
  }
  loadBySalesOrderResponse = (response) => {
    let salesData = response.data.salesOrderPageList.salesOrders;
    let simpleAutoCompleteList = new Array();
    if (salesData.length > 0 && salesData != null) {
      salesData.map((salesCode) => {
        let simpleItemBean = {
          code: salesCode.code,
          description: "",
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      salesPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  salesCodeEnterKeyEventHandler = (e) => {
    let salesCode = e.target.value;
    this.loadSalesOrderDetail(salesCode);
    this.setState({
      salesPageListForAutoCompleteList: new Array(),
      isShowProgressBarPopup: true,
      progressLoadingText: "Loading... ",
    });
  };
  displayAutoCompleteSalesList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteSOList: showAutoCompleteList });
  };
  onPickTicketChange = (e) => {
    let pickTicket = e.target.value;
    this.state.showAutoCompletePTList = true;
    let criteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompletePTList;
    if (isEmpty(pickTicket)) {
      this.state.showAutoCompletePTList = false;
      let showAutoCompleteList = this.state.showAutoCompletePTList;
      let criteria = this.state.criteria;
      criteria.pickTicketNumber = "";
      let suggestion = [];
      this.setState({
        showAutoCompletePTList: showAutoCompleteList,
        criteria: criteria,
        pickTicketPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "pickTicketNumber" &&
      showAutoCompleteList == true &&
      pickTicket !== ""
    ) {
      this.loadPickTicketBySearchString(e.target.value);
    }
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  loadPickTicketDetail = (pickTicket) => {
    let listrequest = new RestReadRequest();
    listrequest.companyCode = this.companyCode;
    listrequest.code = pickTicket;
    PickTicketService.readPickTicket(
      listrequest,
      this.loadPickTicketResponse,
      this.errorCallBack
    );
  };
  loadPickTicketResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.pickTicket != null) {
      let pickTicket = response.data.pickTicket;
      criteria.pickTicketNumber = pickTicket.code;
      let showAutoCompletePTList = false;
      this.setState({
        criteria: criteria,
        showAutoCompletePTList: showAutoCompletePTList,
        progressLoadingText: " ",
      });
    }
  };
  loadPickTicketBySearchString(searchString) {
    let searchCriteria = new PickTicketSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.pickTicketNumberStartsWith = searchString;
    searchCriteria.pickTicketNumberContains = searchString;
    let pageList = new PageListBean();
    pageList.pageSize = 100;
    let input = new RestPickTicketListRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    PickTicketService.getPickTicketPageList(
      input,
      this.loadByPickTicketResponse,
      this.errorCallBack
    );
  }
  loadByPickTicketResponse = (response) => {
    let pickTicketData = response.data.pickTicketPageList.pickTickets;
    let simpleAutoCompleteList = new Array();
    if (pickTicketData.length > 0 && pickTicketData != null) {
      pickTicketData.map((pickTicket) => {
        let simpleItemBean = {
          code: pickTicket.code,
          description: "",
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      pickTicketPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  PickTicketEnterKeyEventHandler = (e) => {
    let pickTicket = e.target.value;
    this.loadPickTicketDetail(pickTicket);
    this.setState({
      pickTicketPageListForAutoCompleteList: new Array(),
    });
  };

  displayAutoCompletePickTicketList = (showAutoCompleteList) => {
    this.setState({ showAutoCompletePTList: showAutoCompleteList });
  };
  clearCriteria = () => {
    let criteria = new InvoiceSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.customerCode = " ";
    criteria.customerName = " ";
    this.setState({
      criteria: criteria,
      isShowClearCriteriaButton: true,
      isShowResetButton: false,
    });
  };
  resetInquiry = () => {
    let criteria = new InvoiceSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.customerCode = "";
    criteria.customerName = "";
    this.setState({
      criteria: criteria,
      isInvoiceDataListFound: false,
      isDisableFields: false,
      ivoiceDatalist: new Array(),
      isShowClearCriteriaButton: true,
      isShowResetButton: false,
    });
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    } else if (type == 4) {
      errMsg = "Mail Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  customerEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.loadCustomerDetail(customerCode);
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Reading customerCode ...",
    });
    this.setState({ customerPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompletecustomerList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricList: showAutoCompleteList });
  };
  approveInvoice = (e, data) => {
    if (e.detail == 1) {
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Approving ...",
      });
      let reportBean = new RestReportBean();
      reportBean.reportType = 1;
      let listRequest = new RestInvoiceBeanRequest();
      listRequest.code = data.code;
      listRequest.companyCode = this.companyCode;
      listRequest.inputReportBean = reportBean;
      if (SecurityAccessManager.MassApproveInvoices_IsAccessible()) {
        InvoiceService.approveInvoiceThenGenerateInvoiceReport(
          listRequest,
          this.generateMassApprovePageDetailResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(1);
      }
    }
  };
  generateMassApprovePageDetailResponse = (response) => {
    this.handleResponse(response.data);
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.printReportResponse) &&
      !isEmpty(response.data.printReportResponse.reportResult)
    ) {
      if (
        !isEmptyString(
          response.data.printReportResponse.reportResult.reportFileID
        )
      ) {
        let reportFilePath =
          response.data.printReportResponse.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
        this.loadPage(1);
      }
    }
  };
  handleResponse = (response) => {
    let success = false;
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
      success = false;
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successMsg = [];
      response.infos.map(
        (info) => (infoMsg = infoMsg + info.messageDescription)
      );
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
      success = true;
    }
    return success;
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail == 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSorting(sortField, sortOrder);
    }
  };
  handleSorting = (sortField, sortOrder) => {
    let ivoiceDatalist = this.state.ivoiceDatalist;
    if (sortField && !isEmptyArray(ivoiceDatalist)) {
      const sorted = [...ivoiceDatalist].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ ivoiceDatalist: sorted });
    }
  };
  render() {
    let ivoiceDatalist = this.state.ivoiceDatalist;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          pageTitle={this.state.pageTitle}
          isShowExitButton={this.state.isShowExitButton}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          onModuleExit={this.onModuleExit}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          reset={this.resetInquiry}
        />
        <CriteriaView
          {...this.state}
          onChange={this.onChange}
          customerCodeRef={this.customerCodeRef}
          customerCodeOnChange={this.customerCodeOnChange}
          onSalesOrderChange={this.onSalesOrderChange}
          onPickTicketChange={this.onPickTicketChange}
          customerCodeEnterKeyEventHandler={
            this.customerCodeEnterKeyEventHandler
          }
          displayAutoCompleteList={this.displayAutoCompleteList}
          salesCodeEnterKeyEventHandler={this.salesCodeEnterKeyEventHandler}
          displayAutoCompleteSalesList={this.displayAutoCompleteSalesList}
          PickTicketEnterKeyEventHandler={this.PickTicketEnterKeyEventHandler}
          displayAutoCompletePickTicketList={
            this.displayAutoCompletePickTicketList
          }
        />
        {this.state.isInvoiceDataListFound && (
          <>
            <Row>
              <FormLabel className="table_title">Invoice List</FormLabel>
            </Row>

            <div className="div_default">
              <Table id="fabrics_tables">
                <thead>
                  <th
                    onClick={(e) => this.handleSortingChange(e, "customerCode")}
                  >
                    Customer{" "}
                    {this.state.order === "desc" &&
                    this.state.sortField === "customerCode" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) => this.handleSortingChange(e, "customerName")}
                  >
                    {" "}
                    Customer Name{" "}
                    {this.state.order === "desc" &&
                    this.state.sortField === "customerName" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "salesOrderNumber")
                    }
                  >
                    {" "}
                    Sales Order{" "}
                    {this.state.order === "desc" &&
                    this.state.sortField === "salesOrderNumber" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "pickTicketNumber")
                    }
                  >
                    {" "}
                    PickTicket{" "}
                    {this.state.order === "desc" &&
                    this.state.sortField === "pickTicketNumber" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th onClick={(e) => this.handleSortingChange(e, "code")}>
                    {" "}
                    Sales Invoice{" "}
                    {this.state.order === "desc" &&
                    this.state.sortField === "code" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "invoiceStatus")
                    }
                  >
                    {" "}
                    Status{" "}
                    {this.state.order === "desc" &&
                    this.state.sortField === "invoiceStatus" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) => this.handleSortingChange(e, "createdDate")}
                  >
                    {" "}
                    Created date
                    {this.state.order === "desc" &&
                    this.state.sortField === "createdDate" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th> </th>
                </thead>
                <tbody>
                  {ivoiceDatalist.map((data, index) => (
                    <tr key={index}>
                      <td>
                        <Button
                          size="sm"
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) =>
                            this.viewCustomerModule(e, data.customerCode)
                          }
                        >
                          {data.customerCode}
                        </Button>
                      </td>
                      <td>{data.customerName} </td>
                      <td>
                        <Button
                          size="sm"
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) =>
                            this.viewsalesOrderModule(e, data.salesOrderNumber)
                          }
                        >
                          {data.salesOrderNumber}
                        </Button>
                      </td>
                      <td>
                        <Button
                          size="sm"
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) =>
                            this.viewPickTicketModule(e, data.pickTicketNumber)
                          }
                        >
                          {data.pickTicketNumber}
                        </Button>
                      </td>
                      <td>
                        <Button
                          size="sm"
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) => this.viewInvoiceModule(e, data.code)}
                        >
                          {data.code}
                        </Button>
                      </td>
                      <td>
                        {" "}
                        {ModuleUtils.getInvoiceStatusCaption(
                          data.invoiceStatus
                        )}
                      </td>
                      <td>{data.createdDate} </td>
                      <td>
                        <Button
                          id="fabric_Add_Button"
                          onClick={(e) => this.approveInvoice(e, data)}
                        >
                          Approve Invoice
                        </Button>{" "}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              {ivoiceDatalist.length != 0 ? null : (
                <div className="no_Data">{"NO DATA"}</div>
              )}
              <MultiViewPopup
                isModulePopup={true}
                id="modulePopup"
                isShowPopup={this.state.isShowCustomerModule}
                popupLvlClass={"popupSizeLeve10"}
                closeModalCallBack={this.closeModalCallBack}
                module={this.state.moduleForPopup}
              ></MultiViewPopup>
              <MultiViewPopup
                isModulePopup={true}
                id="modulePopup"
                isShowPopup={this.state.isShowPickTicketModule}
                popupLvlClass={"popupSizeLevel0"}
                closeModalCallBack={this.closeModalCallBack}
                module={this.state.moduleForPopup}
              ></MultiViewPopup>
              <MultiViewPopup
                isModulePopup={true}
                id="modulePopup"
                isShowPopup={this.state.isShowInvoiceModule}
                popupLvlClass={"popupSizeLevel0"}
                closeModalCallBack={this.closeModalCallBack}
                module={this.state.moduleForPopup}
              ></MultiViewPopup>
              <MultiViewPopup
                isModulePopup={true}
                id="modulePopup"
                isShowPopup={this.state.isShowSalesOrderMaintenanceModule}
                popupLvlClass={"popupSizeLevel0"}
                closeModalCallBack={this.closeModalCallBack}
                module={this.state.moduleForPopup}
              ></MultiViewPopup>
            </div>
          </>
        )}
      </div>
    );
  }
}
export function CriteriaView(props) {
  const [show, setShow] = useState(false);
  const onChange = (e) => props.onChange(e);
  let criteria = props.criteria;
  const customerCodeRef = props.customerCodeRef;
  let customerLookupHandler = props.customerLookupHandler;
  let pickTicketRef = React.createRef();
  let pickTicketLookupHandler = props.pickTicketLookupHandler;
  let salesOrderRef = React.createRef();
  let salesOrderLookupHandler = props.salesOrderLookupHandler;
  const customerCodeOnChange = (e) => props.customerCodeOnChange(e);
  const onSalesOrderChange = (e) => props.onSalesOrderChange(e);
  const onPickTicketChange = (e) => props.onPickTicketChange(e);
  const customerCodeEnterKeyEventHandler = (e) => {
    props.customerCodeEnterKeyEventHandler(e);
  };
  const displayAutoCompleteList = () => {
    props.displayAutoCompleteList();
  };
  const salesCodeEnterKeyEventHandler = (e) => {
    props.salesCodeEnterKeyEventHandler(e);
  };
  const displayAutoCompleteSalesList = () => {
    props.displayAutoCompleteSalesList();
  };
  const PickTicketEnterKeyEventHandler = (e) => {
    props.PickTicketEnterKeyEventHandler(e);
  };
  const displayAutoCompletePickTicketList = () => {
    props.displayAutoCompletePickTicketList();
  };
  return (
    <div>
      <Row className="d-flex justify-context-left">
        <Col sm="1">
          <FormLabel> Customer </FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={customerCodeRef}
            name="customerCode"
            onChange={customerCodeOnChange}
            lookupHandler={customerLookupHandler}
            value={criteria.customerCode}
            showCriteriaDialog={true}
            lookupRequired={true}
            enterKeyEventHandler={customerCodeEnterKeyEventHandler}
            autoCompleteListData={props.customerPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteList}
            showAutoCompleteList={props.showAutoCompleteCustomerList}
            disabled={props.isDisableFields}
            isMandatory={true}
          />
        </Col>
        <Col sm="3">
          <InputTextbox
            name="customerName"
            onChange={onChange}
            value={criteria.customerName}
            disabled={true}
          />
        </Col>
        <Col sm="1">
          <FormLabel>Stop Date From</FormLabel>
        </Col>
        <Col sm="2">
          <DatePickerComponent
            name="invoiceFromDate"
            onChange={onChange}
            value={criteria.invoiceFromDate}
            disabled={props.isDisableFields}
          ></DatePickerComponent>
        </Col>
        <Col sm="1">
          <FormLabel>Stop Date To</FormLabel>
        </Col>
        <Col sm="2">
          <DatePickerComponent
            name="invoiceToDate"
            value={criteria.invoiceToDate}
            onChange={onChange}
            disabled={props.isDisableFields}
          ></DatePickerComponent>
        </Col>
      </Row>
      <Row>
        <Col sm="1">
          <FormLabel>PickTicket Number </FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={pickTicketRef}
            onChange={onPickTicketChange}
            name="pickTicketNumber"
            lookupRequired={true}
            lookupHandler={pickTicketLookupHandler}
            value={criteria.pickTicketNumber}
            showCriteriaDialog={true}
            enterKeyEventHandler={PickTicketEnterKeyEventHandler}
            autoCompleteListData={props.pickTicketPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompletePickTicketList}
            showAutoCompleteList={props.showAutoCompletePTList}
            disabled={props.isDisableFields}
            isMandatory={true}
          />
        </Col>
        <Col sm="1">
          <FormLabel> SaleOrder Number </FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            onChange={onSalesOrderChange}
            name="salesOrderNumber"
            ref={salesOrderRef}
            lookupRequired={true}
            lookupHandler={salesOrderLookupHandler}
            value={criteria.salesOrderNumber}
            showCriteriaDialog={true}
            enterKeyEventHandler={salesCodeEnterKeyEventHandler}
            autoCompleteListData={props.salesPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteSalesList}
            showAutoCompleteList={props.showAutoCompleteSOList}
            disabled={props.isDisableFields}
            isMandatory={true}
          />
        </Col>
      </Row>
    </div>
  );
}
function ApproveInvoiceModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="App">
        <ApproveInvoice {...props} name="" /> <br />
      </div>
    </div>
  );
}

export default ApproveInvoiceModule;
